import { Chip, Grid, Button } from '@material-ui/core';
import {
  AcUnit as AcUnitIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  CancelOutlined as CancelOutlinedIcon,
  CheckCircle as CheckCircleIcon,
  Code as CodeIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
  Delete as DeleteIcon,
  DoneAll as DoneAllIcon,
  Event as EventIcon,
  FileCopy as FileCopyIcon,
  MoreHoriz as MoreHorizIcon,
  Search as PageviewIcon,
  Print as PrintIcon,
  Receipt as ReceiptIcon,
  Schedule as ScheduleIcon,
  CallMissed as CallMissedIcon,
} from '@material-ui/icons';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscription } from 'react-stomp-hooks';
import moment from 'moment';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { Circle as CircleIcon } from '@mui/icons-material';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import ReplayIcon from '@mui/icons-material/Replay';
import _, { isEmpty, isFunction } from 'lodash';
import { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { FaCalculator as FaCalculatorIcon } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import QCXGenericDownloader from '../../../../components/downloader/QCXGenericDownloader';
import QCXMoveFocusInside from '../../../../components/focus-lock/QCXMoveFocusInside';
import { userHasCreateRole, userHasDeleteRole, userHasUpdateRole } from '../../../../components/perfil/perfil-utils';
import QCXPopupState from '../../../../components/popup-state/QCXPopupState';
import DeclaracaoImportacaoContext from '../../../../contexts/import/declaracao-importacao/DeclaracaoImportacaoContext';
import { clienteActions } from '../../../../features/cliente/clienteSlice';
import { IDLE_CONTROL } from '../../../../features/config-control';
import { setQuery } from '../../../../features/controller/controllerSlice';
import {
  declaracaoImportacaoAPI,
  fetchByDuimpsByIdFatura,
} from '../../../../features/declaracao-importacao/declaracaoImportacaoAPI';
import RelatorioTransmissaoDuimpPopup from './RelatorioPopUp';
import {
  selectDeclaracoesImportacao,
  selectDeclaracoesImportacaoCount,
  selectHistoryModel,
  selectMode,
  selectRelatedCalculoModel,
  selectRelatedDuplicataModel,
  selectRelatedEmissaoIcmsModel,
  selectRelatedMultaModel,
  selectRelatedRegistroModel,
  selectRelatedReportModel,
  selectRelatedSelectionDeclaracaoImportacao,
} from '../../../../features/declaracao-importacao/declaracaoImportacaoSelectors';
import {
  changeLastHistoryModel,
  changeToCalculateModeDI,
  changeToConsultMode,
  changeToCreateMode,
  changeToRegisterModeDI,
  changeToReleaseModeDI,
  changeToRetransmitirModeDI,
  changeToLiberarModeDI,
  failure,
  loading,
  loadingDI,
  resetBackgroundMode,
  resetHistoryModel,
  resetMode,
  resetModel,
  resetRelatedEmissaoIcmsModel,
  resetRelatedRegistroModel,
  resetRelatedReportModel,
  resetSubMode,
  setProcesso,
  setRelatedCalculoModel,
  setRelatedDuplicataModel,
  setRelatedEmissaoIcmsModel,
  setRelatedRegistroModel,
  setRelatedReportModel,
  setRelatedSelectionDeclaracaoImportacaoList,
  success,
  updateOnList,
  setRelatedMultaModel,
  resetRelatedMultaModel,
} from '../../../../features/declaracao-importacao/declaracaoImportacaoSlice';
import {
  activateByIdFromFaturaAsync,
  calcularDisLoteAsync,
  conferirByIdFromFaturaAsync,
  diagnosticoDiByIdAsync,
  duplicarByIdFromFaturaAsync,
  fetchAllDecImportWithPaginationAsync,
  generateReportDIDiagnosticoAsync,
  generateReportDIRegistroAsync,
  gerarXMLDIagnosticoLoteAsync,
  inactivateByIdFromFaturaAsync,
  liberarByIdFromFaturaAsync,
  reabrirByIdAsync,
  releaseDisEmLoteAsync,
  retransmitirDisEmLoteAsync,
  liberarDisEmLoteAsync,
  retransmitirByIdFromFaturaAsync,
  transmissaoDuimpByIdAsync,
  transmissaoDiagnosticoDuimpByIdAsync,
  registrarDuimpByIdAsync,
  obterChavesDuimpAsync,
} from '../../../../features/declaracao-importacao/declaracaoImportacaoThunks';
import { faturaAPI } from '../../../../features/fatura/faturaAPI';
import { setErrorFeedback, setSuccessFeedback } from '../../../../features/feedback/feedbackSlice';
import { followUpAPI } from '../../../../features/follow-up/followUpAPI';
import { followUpActions } from '../../../../features/follow-up/followUpSlice';
import { changeControlTo as changeControlNaladiShTo } from '../../../../features/naladi-sh/naladiShSlice';
import { changeControlTo as changeControlNcmTo } from '../../../../features/ncm-subitem/ncmSubitemSlice';
import { changeControlTo as changeControlPaisTo } from '../../../../features/pais/paisSlice';
import { changeControlTo as changeControlUnidadeMedidaTo } from '../../../../features/unidade-medida/unidadeDeMedidaSlice';
import { selectUnidadeSelecionada } from '../../../../features/usuario-logado/usuarioLogadoSlice';
import QCXButton from '../../../../shared-components/button/QCXButton';
import QCXConfirmDialog from '../../../../shared-components/dialog/QCXConfirmDialog';
import QCXFinalFormDialog from '../../../../shared-components/dialog/QCXFinalFormDialog';
import QCXFinalDatePickerField from '../../../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXFinalRadioField from '../../../../shared-components/final-radio-field/QCXFinalRadioField';
import QCXFinalTextField from '../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXListItemIcon from '../../../../shared-components/list-item-icon/QCXListItemIcon';
import QCXSelectFollowUpImportacaoAutocompleteField from '../../../../shared-components/select-follow-up/QCXSelectFollowUpImportacaoAutocompleteField';
import { TipoProdutoUtils } from '../../../../shared-components/select-tipo-produto/tipoProdutoUtils';
import SimpleConsultPageTemplate from '../../../../templates/simple-consult-page/SimpleConsultPageTemplate/SimpleConsultPageTemplate';
import TransmissaoModal from '../../../../ts/common/components/modals/transmissaoModal';
import useConfigurePopUp from '../../../../ts/common/hooks/popUps/useConfigurePopUp';
import { GERARXML, TRANSMISSAO } from '../../../../ts/common/hooks/useHasPermission/permissionsEnum.ts';
import { useHasPermission } from '../../../../ts/common/hooks/useHasPermission/useHasPermission.ts';
import {
  fetchDataDiagnostico,
  fetchRelatorioTransmissaoDuimp,
} from '../../../../ts/common/services/declaracaoImportacaoApi';
import { TransmissaoRenderDadosDi } from '../../../../ts/pages/importacao/declaracaoImportacao/components/TransmissaoRenderDados/transmissaoRenderDadosDi';
import ConfirmationModal from '../../../../ts/pages/integracao/planilhas/components/confirmationModal';
import { DECLARACAO_IMPORTACAO_ENDPOINT } from '../../../../utils/api/domain/domain-endpoint-utils';
import CanalLiberacaoUtils from '../../../../utils/general/declaracao-Importacao/CanalLiberacaoUtils';
import { TIPO_DI_DUIMP } from '../../../../utils/general/fatura/faturaUtils';
import { formatDate, getCurrentDate, normalizeData, normalizeNumeral } from '../../../../utils/general/general-utils';
import {
  isCalculadaStatus,
  isConferidaStatus,
  isLiberadaStatus,
  isNaoCalculadaStatus,
  isNaoConferidaStatus,
} from '../../../../utils/general/operations/operationUtils';
import { ReportUtils } from '../../../../utils/general/report/reportUtils';
import useGenericDownloader from '../../../../utils/hooks/downloader/useGenericDownloader';
import {
  AWAITING_STATUS,
  CLOSED_STATUS,
  DONE_STATUS,
  FAIL_STATUS,
  OPEN_STATUS,
  SUBMITTING_STATUS,
  isAwaitingStatus,
  isOpenStatus,
} from '../../../../utils/hooks/form/dialog/formDialogUtils';
import useFormDialogAsync from '../../../../utils/hooks/form/dialog/useFormDialogAsync';
import useFormDialogSync from '../../../../utils/hooks/form/dialog/useFormDialogSync';
import { formatNumeroDI } from '../../../../utils/hooks/form/field/formatters';
import useOperationMiddleware from '../../../../utils/hooks/operation/middleware/useOperationMiddleware';

import {
  isAlternativeLoadingStatus,
  isCalculateMode,
  isLoadingStatus,
  isNoneMode,
  isRegisterMode,
  isReleaseMode,
  isRetransmitirMode,
  isLiberarMode,
} from '../../../../utils/store/store-utils';

import FiltrosDuimpToConsultPage from './FiltrosDuimpToConsultPage';
import { required } from '../../../../utils/validators/field/validator';
import StatusICMSUtils from '../../../../utils/general/declaracao-Importacao/StatusICMSUtils';
import StatusDuimpUtils from '../../../../utils/general/declaracao-Importacao/StatusDuimpUtils';
import SelectTipoRateioDespesasAcessorias from '../../../../shared-components/despesas-acessorias-form-group/SelectTipoRateio';
import QCXFinalAlternativeCurrencyField from '../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import DeclaracaoImportacaoActionsMenu from './DeclaracaoImportacaoActionsMenu/DeclaracaoImportacaoActionsMenu';

import ModalRelatorioCalculo from './RelatorioCalculoDi/ModalRelatorioCalculo';

import SelectDespachanteModal from './SelectDespachanteModal';
import useCurrentUnidadeNegocio from '../../../../utils/hooks/user/useCurrentUnidadeNegocio';
import { doPutQCXRequest } from '../../../../utils/api/domain/domain-api-utils';

export default function DeclaracaoImportacaoConsultPage({ authInfo = {} }) {
  const { t } = useTranslation();

  const history = useHistory();

  const unidadeNegocioSelecionada = useCurrentUnidadeNegocio();

  const {
    handleDiagnosticoCrawlerClick,
    diagnosticoDiPopUpConfig,
    handleCalcularClick,
    handleFormDialogCalculoStatus,
    handleTransmissaoDuimp,
    reabriDiPopUpConfig,
    formDialogDadosRegistroSiscomexStatus,
    handleFormDialogDadosRegistroSiscomexStatus,
    filterAvailableFollowUp,
    fetchAll,
    isCalculate,
    exibirModalRelatorioCalculoDi,
    setExibirModalRelatorioCalculoDi,
    deleteTransmissaoDuimpPopup,
    exibirModalDespachante,
    setExibirModalDespachante,
  } = useContext(DeclaracaoImportacaoContext);

  const [idDiToTransmissao, setIdDiToTransmissao] = useState(null);
  const [isDuimpSelected, setIsDuimpSelected] = useState(null);
  const [faturaSelected, setFaturaSelected] = useState(null);
  const [currentMessage, setCurrentMessage] = useState(null);
  const selectedUnidade = useSelector(selectUnidadeSelecionada);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [decisionPromiseResolver, setDecisionPromiseResolver] = useState(() => {});
  const [idIntervalStateTransmission, setIdIntervalStateTransmission] = useState(null);
  const [arrDuimpsEmTransmissao, setArrDuimpsEmTransmissao] = useState([]);
  const [currentAdvancedFilter, setCurrentAdvancedFilter] = useState({});

  const [tipoXML, setTipoXML] = useState('DIAGNOSTICO'); // DIAGNOSTICO ou REGISTRO -> usado para gerar o xml em lote

  const mode = useSelector(selectMode);
  const isRegister = useMemo(() => isRegisterMode(mode), [mode]);
  const isRelease = useMemo(() => isReleaseMode(mode), [mode]);
  const isRetransmitir = useMemo(() => isRetransmitirMode(mode), [mode]);
  const isLiberar = useMemo(() => isLiberarMode(mode), [mode]);
  const isNone = useMemo(() => isNoneMode(mode), [mode]);

  const relatedSelectionDeclaracaoImportacaoList = useSelector(selectRelatedSelectionDeclaracaoImportacao);

  const isEmptySelectionList = useMemo(
    () =>
      !relatedSelectionDeclaracaoImportacaoList ||
      (_.isArrayLikeObject(relatedSelectionDeclaracaoImportacaoList) &&
        _.isEmpty(relatedSelectionDeclaracaoImportacaoList)),
    [relatedSelectionDeclaracaoImportacaoList]
  );

  const handleSelectionModelChange = useCallback(
    ({ selectionModel }) => {
      if (isRegister || isCalculate || isRelease || isLiberar || isRetransmitir) {
        dispatch(setRelatedSelectionDeclaracaoImportacaoList(selectionModel));
      }
    },
    [isRegister, isCalculate, isRelease, isLiberar, isRetransmitir]
  );

  // Permissions
  const canGenerateDIDiag = useHasPermission(GERARXML.DIAGNOSTICODI);
  const canGenerateTransmissaoDiagnosticoDI = useHasPermission(TRANSMISSAO.DIAGNOSTICODI);

  const canGerenateDIReg = useHasPermission(GERARXML.REGISTRODI);
  const canGenerateTransmissaoRegistroDI = useHasPermission(TRANSMISSAO.REGISTRODI);

  // Função para formato de data conforme ISO 8601 para ano, mês, dia, hora e segundo
  function getISODateOrTodaysISODate(dateString) {
    return dateString ? moment(dateString).toISOString() : moment().toISOString();
  }

  // Função para formato de data para ano, mês e dia
  function formatDateToYYYYMMDD(dataValue) {
    if (dataValue) {
      return moment(dataValue).format('YYYY-MM-DD');
    }

    return null;
  }

  const { status } = useContext(DeclaracaoImportacaoContext);

  const dispatch = useDispatch();

  const declaracoesImportacao = useSelector(selectDeclaracoesImportacao);
  const registroRelatedModel = useSelector(selectRelatedRegistroModel);
  const historyModel = useSelector(selectHistoryModel);

  useEffect(() => {
    const idsFaturasEmTela = declaracoesImportacao.map((el) => el.id);

    for (let i = 0; i < arrDuimpsEmTransmissao.length; i += 1) {
      const idFaturaDuimp = arrDuimpsEmTransmissao[i];

      if (!idsFaturasEmTela.includes(idFaturaDuimp)) {
        // fatura monitorada saiu da tela !!
        setArrDuimpsEmTransmissao([]);
        break;
      }
    }
  }, [declaracoesImportacao]);

  useEffect(() => {
    if (idIntervalStateTransmission) {
      clearInterval(idIntervalStateTransmission);
    }

    if (!arrDuimpsEmTransmissao || arrDuimpsEmTransmissao.length === 0) {
      setIdIntervalStateTransmission(null);
      return;
    }

    const idInterval = setInterval(async () => {
      const idsArrStr = arrDuimpsEmTransmissao.join(';');

      const estadoTransmissao = await fetchByDuimpsByIdFatura([{ name: 'ids', value: idsArrStr }]);

      const transmisssoes = estadoTransmissao.data;
      if (!transmisssoes) return;

      for (let i = 0; i < transmisssoes.length; i += 1) {
        const transmissaoAtual = transmisssoes[i];
        const { idFatura, statusTransmissao, numeroTransmissao } = transmissaoAtual;

        let declaracao = declaracoesImportacao.find((el) => el.id === idFatura);

        if (declaracao) {
          let isAlterado = false;
          let numeroTransmissaoAtualizado = declaracao.atributosAdicionais?.numeroTransmissao;
          let statusTransmissaoAtualizado = declaracao.atributosAdicionais?.statusTransmissaoDuimp;

          if (statusTransmissaoAtualizado !== statusTransmissao) {
            statusTransmissaoAtualizado = statusTransmissao;
            isAlterado = true;
          }

          if (numeroTransmissaoAtualizado !== numeroTransmissao) {
            numeroTransmissaoAtualizado = numeroTransmissao;
            isAlterado = true;
          }

          if (isAlterado) {
            declaracao = {
              ...declaracao,
              atributosAdicionais: {
                ...declaracao.atributosAdicionais,
                numeroTransmissao: numeroTransmissaoAtualizado,
                statusTransmissaoDuimp: statusTransmissaoAtualizado,
              },
            };

            dispatch(updateOnList({ data: declaracao }));
          }
        }
      }
    }, 3000);

    setIdIntervalStateTransmission(idInterval);
  }, [arrDuimpsEmTransmissao]);

  const isAlternativeLoading = useMemo(() => isAlternativeLoadingStatus(status), [status]);
  const isLoading = useMemo(() => isLoadingStatus(status), [status]);

  const finalLoading = useMemo(() => isAlternativeLoading || isLoading, [isAlternativeLoading, isLoading]);

  const defaultDateValue = useMemo(() => getCurrentDate(), []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalNovoRelatorioDuimpOpen, setIsModalNovoRelatorioDuimpOpen] = useState(false);
  const [resultadoRelatorioDuimp, setResultadoRelatorioDuimp] = useState({});
  const [isNovoRelatorio, setIsNovoRelatorio] = useState(false);
  const [dataDiagnostico, setDataDiagnostico] = useState(null);
  const [processoDiagnostico, setProcessoDiagnostico] = useState(null);
  const [exibirModalTransmissaoDuimp, setExibirModalTransmissaoDuimp] = useState(false);
  const [modelDuimpSelecionada, setModelDuimpSelecionada] = useState({});
  const showButtonTransmitirSemTributos = useMemo(() => {
    const diagnosticos = dataDiagnostico?.diagnostico ?? [];
    const listaDiagnosticos = dataDiagnostico?.listaDiagnostico ?? [];
    const todosDiagnosticos = diagnosticos.concat(listaDiagnosticos);
    const listasErros = todosDiagnosticos.map((d) => d?.erros ?? []);
    const mensagensErros = listasErros.map((erros) => erros.map((e) => e?.mensagem ?? '')).join('. ');

    return mensagensErros.includes('Para codigoAgregacao/idRegime/idFundamentoLegal');
  }, [dataDiagnostico]);

  console.log('data diag', dataDiagnostico);

  const resetModes = useCallback(() => {
    dispatch(resetMode());
    dispatch(resetBackgroundMode());
    dispatch(resetSubMode());
  }, []);

  const resetModels = useCallback(() => {
    dispatch(resetModel());
    dispatch(resetHistoryModel());
  }, []);

  const resetDependencies = useCallback(() => {
    dispatch(changeControlPaisTo(IDLE_CONTROL));
    dispatch(changeControlNcmTo(IDLE_CONTROL));
    dispatch(changeControlNaladiShTo(IDLE_CONTROL));
    dispatch(changeControlUnidadeMedidaTo(IDLE_CONTROL));
  }, []);

  const configureDependencies = useCallback(() => {
    dispatch(clienteActions.changeControlTo(IDLE_CONTROL));
  }, []);

  useEffect(() => {
    resetModes();
    resetModels();
    resetDependencies();
    setCurrentMessage(null);
    setConfirmModalOpen(false);

    return () => {
      // funcao executada na desmontagem do componente
      if (idIntervalStateTransmission) {
        clearInterval(idIntervalStateTransmission);
      }
    };
  }, []);

  useEffect(() => {
    const checkIfExistsQuery = () => {
      if (!isEmpty(historyModel) && historyModel?.last?.processo) {
        dispatch(setQuery(historyModel?.last?.processo));
      }
    };

    checkIfExistsQuery();
  }, [historyModel]);

  const [handleInformarDadosRegistroSiscomexClickMiddleware, operationOfInformarDadosRegistroSiscomex] =
    useOperationMiddleware(
      async (values) => {
        try {
          dispatch(loading());
          const responseFollowUp = await followUpAPI.fetchByFilter([
            { name: 'processo', value: values?.processo },
            { name: 'servicoProduto', value: 'IMPORTACAO' },
          ]);
          if (!responseFollowUp) {
            dispatch(setErrorFeedback({ message: 'Processo não encontrado.' }));
            return;
          }

          if (responseFollowUp?.status === 200) {
            const followUp = responseFollowUp?.data?.[0];
            if (followUp?.bloqueado) {
              dispatch(
                setErrorFeedback({
                  message: 'Follow up Bloqueado no Financeiro',
                })
              );
              dispatch(failure());
              return;
            }
          } else {
            dispatch(
              setErrorFeedback({
                message: 'Erro ao buscar o follow up',
              })
            );
            dispatch(failure());
            return;
          }
          handleFormDialogDadosRegistroSiscomexStatus(SUBMITTING_STATUS);
          console.log(values);

          const updated = {
            id: values?.id,
            atributosAdicionais: {
              tipo: TIPO_DI_DUIMP,
              registro: values?.registro,
              numeroTransmissao: values?.numeroTransmissao,
              dataRegistroSiscomex: normalizeData(values?.dataRegistroSiscomex),
            },
          };

          try {
            // await declaracaoImportacaoAPI.repassaImpostosComissaria(values?.id);
            console.log('repassaImpostosComissaria');
          } catch (err) {
            // ignora erro, caso conta não controlar saldo por exemplo
          }

          const response = await declaracaoImportacaoAPI.save(updated);

          if (response?.status === 200) {
            dispatch(
              setSuccessFeedback({
                message: t('com.muralis.qcx.mensagem.numeroRegistroDIDUIMPSalvo', { processo: values?.processo }),
              })
            );

            handleFormDialogDadosRegistroSiscomexStatus(DONE_STATUS);
            dispatch(resetRelatedRegistroModel());
            fetchAll();

            dispatch(success());
            dispatch(
              setSuccessFeedback({
                message: t('com.muralis.qcx.mensagem.numeroRegistroDIDUIMPSalvo', { processo: values?.processo }),
              })
            );
          }
        } catch (error) {
          handleFormDialogDadosRegistroSiscomexStatus(FAIL_STATUS);

          let errorMessage = t('com.muralis.qcx.erro.erroSalvarDIDUIMP');
          if (error?.response && error?.response?.data) {
            errorMessage = t('com.muralis.qcx.erro.erroSalvarDIDUIMPEspecifico', {
              erro: error?.response?.data?.message,
            });
          }

          dispatch(
            setErrorFeedback({
              message: errorMessage,
            })
          );
        }
      },
      [handleFormDialogDadosRegistroSiscomexStatus]
    );

  const handleConfigureInformarDadosRegistroSiscomexByIdClick = useCallback(
    (values) => {
      const formattedDataRegistroSiscomex = formatDate(values?.dataRegistroSiscomex);

      const configureOperation = () => ({
        options: {
          title: t('com.muralis.qcx.autorizarOperacaoDadosRegistro').toUpperCase(),
          message: t('com.muralis.qcx.confirmarNumeroRegistroDataRegistroNaoPoderaoAlterar', {
            registro: values?.registro,
            data: formattedDataRegistroSiscomex,
          }),
          endMessage: t('com.muralis.qcx.certezaConfirmarDados'),
        },
      });

      handleInformarDadosRegistroSiscomexClickMiddleware(configureOperation, values);
    },
    [handleInformarDadosRegistroSiscomexClickMiddleware]
  );

  const handleCloseDadosRegistroSiscomexOperation = useCallback(() => {
    const callback = () => {
      if (isAwaitingStatus(formDialogDadosRegistroSiscomexStatus)) {
        handleFormDialogDadosRegistroSiscomexStatus(OPEN_STATUS);
      }
    };

    operationOfInformarDadosRegistroSiscomex?.reset(callback);
  }, [
    operationOfInformarDadosRegistroSiscomex,
    formDialogDadosRegistroSiscomexStatus,
    handleFormDialogDadosRegistroSiscomexStatus,
  ]);

  const handleDadosRegistroSiscomexSubmit = useCallback(
    async (values) => {
      console.log(values);
      handleFormDialogDadosRegistroSiscomexStatus(AWAITING_STATUS);

      dispatch(
        setRelatedRegistroModel({
          ...values,
          confirmacaoPendente: true,
        })
      );
      handleConfigureInformarDadosRegistroSiscomexByIdClick(values);
    },
    [handleFormDialogDadosRegistroSiscomexStatus, handleConfigureInformarDadosRegistroSiscomexByIdClick]
  );

  const handleCloseFormDialogDadosRegistroSiscomex = useCallback(() => {
    handleFormDialogDadosRegistroSiscomexStatus(CLOSED_STATUS);

    const debouncedReset = _.debounce(() => {
      dispatch(resetRelatedRegistroModel());
    }, 300);

    debouncedReset();
  }, [handleFormDialogDadosRegistroSiscomexStatus]);

  const isFormDialogDadosRegistroSiscomexOpen = useMemo(() => isOpenStatus(formDialogDadosRegistroSiscomexStatus));

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const formDialogAlteracaoNumeroRegistroSiscomexContent = useMemo(
    () => t('com.muralis.qcx.numeroRegistroDIDUIMPSiscomex'),
    []
  );
  const formDialogDadosRegistroSiscomexContent = useMemo(
    () =>
      registroRelatedModel?.confirmacaoPendente ||
      !registroRelatedModel?.registro ||
      !registroRelatedModel?.dataRegistroSiscomex
        ? t('com.muralis.qcx.mensagem.dadosReferenteDIDUIMPSiscomex')
        : t('com.muralis.qcx.mensagem.dadosRegistroReferenteDIDUIMPSiscomexInformados'),
    [registroRelatedModel]
  );

  const [handleButtonNewClick, formDialogNewStatus, handleFormDialogNewStatus] = useFormDialogAsync(
    async (event) => {
      event.stopPropagation();

      configureDependencies();

      dispatch(changeToCreateMode());

      history.push(t('com.muralis.qcx.url.importacaoDeclaracoesNovo'));
    },
    [configureDependencies, history]
  );

  const handleButtonNewClickMiddleware = useCallback(
    async (event) => handleButtonNewClick(event),
    [filterAvailableFollowUp, handleButtonNewClick]
  );

  const handleOpenModalTransmissao = async (row) => {
    const idFaturaRow = row?.id;
    const numTransmissao = row?.atributosAdicionais?.numeroTransmissao;
    setIsNovoRelatorio(false);

    if (false && numTransmissao && `${numTransmissao}`.substring('BR')) {
      const response = await fetchRelatorioTransmissaoDuimp(idFaturaRow);
      console.log(response);

      if (response && response.data) {
        setIsNovoRelatorio(true);
        setResultadoRelatorioDuimp({ ...response.data });
        setIsModalNovoRelatorioDuimpOpen(true);
      }
    } else if (idFaturaRow) {
      const response = await fetchDataDiagnostico(idFaturaRow);

      if (response.message !== null) {
        dispatch(
          setErrorFeedback({
            message: t(`${response.message}`),
          })
        );
      } else {
        setDataDiagnostico(response.data);
        setProcessoDiagnostico(row?.atributosAdicionais?.processo);
        setIdDiToTransmissao(idFaturaRow);
        setIsDuimpSelected(isDuimp(row?.atributosAdicionais));
        setFaturaSelected(row?.atributosAdicionais);
        setIsModalOpen(true);
      }
    }
  };

  const handleProcessoNewSubmit = useCallback(
    async (values) => {
      try {
        dispatch(loading());

        handleFormDialogNewStatus(SUBMITTING_STATUS);

        const response = await followUpAPI.fetchByFilter([
          { name: 'processo', value: values?.numeroProcesso },
          { name: 'servicoProduto', value: 'IMPORTACAO' },
        ]);

        const followUp = response?.data?.[0];

        if (!followUp) {
          dispatch(setErrorFeedback({ message: 'Processo não encontrado.' }));
          return;
        }

        if (response?.status === 200) {
          dispatch(
            setProcesso({
              processo: followUp?.numero,
              followUp,
            })
          );

          handleFormDialogNewStatus(DONE_STATUS);
        }
      } catch (error) {
        handleFormDialogNewStatus(FAIL_STATUS);

        let errorMessage = t('com.muralis.qcx.erro.erroCarregarProcesso');
        if (error?.response && error?.response?.data) {
          errorMessage = t('com.muralis.qcx.erro.erroCarregarProcessoEspecifico', {
            erro: error?.response?.data?.message,
          });
        }

        dispatch(failure());
        dispatch(
          setErrorFeedback({
            message: errorMessage,
          })
        );
      }
    },
    [handleFormDialogNewStatus]
  );

  const handleCloseFormDialogNew = useCallback(
    () => handleFormDialogNewStatus(CLOSED_STATUS),
    [handleFormDialogNewStatus]
  );

  const isFormDialogNewOpen = useMemo(() => isOpenStatus(formDialogNewStatus), [formDialogNewStatus]);

  const transmitirDuimp = (values) => {
    if (modelDuimpSelecionada && modelDuimpSelecionada.id) {
      const { id, atributosAdicionais } = modelDuimpSelecionada;

      handleTransmissaoDuimp({
        declaracaoImportacao: {
          id,
          processo: atributosAdicionais?.processo,
          tipo: 'REGISTRO',
          transmitirComErros: values?.transmitirComErrosNaoImpeditivos === 'SIM',
        },
      });

      setExibirModalTransmissaoDuimp(false);
    }
  };

  const columns = [
    {
      field: 'id',
      headerName: t('com.muralis.qcx.processo'),
      headerAlign: 'center',
      align: 'center',
      flex: 100,
      valueGetter: ({ row }) => row?.atributosAdicionais?.processo || '-',
    },
    {
      field: 'cliente',
      headerName: 'Cliente',
      headerAlign: 'center',
      align: 'center',
      flex: 100,
      valueGetter: ({ row }) => row?.importador?.pessoa?.nomeResumido || '-',
    },
    {
      field: 'numeroConhecimentoHouse',
      headerName: 'Conhecimento House',
      headerAlign: 'center',
      align: 'center',
      flex: 100,
      valueGetter: ({ row }) => row?.numeroConhecimentoHouse || '-',
    },
    {
      field: 'atributosAdicionais.registro',
      headerName: t('com.muralis.qcx.NDIDUIMP'),
      flex: 100,
      valueGetter: ({ row }) =>
        row?.atributosAdicionais?.registro ? formatNumeroDI(row?.atributosAdicionais?.registro) : '-',
    },
    {
      field: 'atributosAdicionais.dataRegistroSiscomex',
      headerName: t('com.muralis.qcx.registro'),
      flex: 100,
      valueGetter: ({ row }) => formatDate(row?.atributosAdicionais?.dataRegistroSiscomex) || '-',
    },
    {
      field: 'atributosAdicionais.retificacao.numero',
      headerName: t('com.muralis.qcx.NRetificado'),
      flex: 110,
      valueGetter: ({ row }) => formatDate(row?.atributosAdicionais?.retificacao?.numero) || '-',
    },
    {
      field: 'atributosAdicionais.numeroTransmissao',
      headerName: t('com.muralis.qcx.numeroTransmissao'),
      headerAlign: 'center',
      align: 'center',
      flex: 100,
      renderCell: ({ row }) => {
        const statusTransmissao = row?.atributosAdicionais?.numeroTransmissao;

        if (statusTransmissao && statusTransmissao.toLowerCase().includes('erro')) {
          const htmlColor = StatusDuimpUtils.getHexadecimalColorByValue('ERRO');
          const label = StatusDuimpUtils.getLabelByValue(statusTransmissao);

          return (
            <>
              <QCXButton
                tooltip
                tooltipDescription={t('com.muralis.qcx.resultadoTransmissao')}
                onClick={() => handleOpenModalTransmissao(row)}
                disabled={!row?.atributosAdicionais?.numeroTransmissao}
                fullWidth
                variant="default"
              >
                <Chip
                  {...(htmlColor
                    ? {
                        icon: (
                          <CircleIcon
                            style={{
                              color: htmlColor,
                            }}
                            fontSize="small"
                          />
                        ),
                      }
                    : {})}
                  label={label}
                  size="small"
                />
              </QCXButton>
            </>
          );
        }

        return (
          <>
            <QCXButton
              tooltip
              tooltipDescription={t('com.muralis.qcx.resultadoTransmissao')}
              onClick={() => handleOpenModalTransmissao(row)}
              disabled={!row?.atributosAdicionais?.numeroTransmissao}
              fullWidth
              variant="default"
            >
              <Typography
                variant="inherit"
                style={{
                  fontSize: 14,
                }}
              >
                {row?.atributosAdicionais?.numeroTransmissao || null}
              </Typography>

              {row?.atributosAdicionais?.numeroTransmissao !== undefined ? (
                <ContentPasteSearchIcon style={{ fontSize: '18px', marginLeft: '8px' }} />
              ) : (
                '-'
              )}
            </QCXButton>
          </>
        );
      },
    },

    {
      field: 'atributosAdicionais.canalLiberacao',
      headerName: t('com.muralis.qcx.canal'),
      headerAlign: 'center',
      align: 'center',
      flex: 100,
      renderCell: ({ row }) => {
        const canal = row?.atributosAdicionais?.canalLiberacao;
        const htmlColor = CanalLiberacaoUtils.getHexadecimalColorByValue(canal);
        const label = CanalLiberacaoUtils.getLabelByValue(canal);

        return canal ? (
          <Chip
            {...(htmlColor
              ? {
                  icon: (
                    <CircleIcon
                      style={{
                        color: htmlColor,
                      }}
                      fontSize="small"
                    />
                  ),
                }
              : {})}
            label={label}
            size="small"
          />
        ) : (
          '-'
        );
      },
    },
    {
      field: 'atributosAdicionais.statusTransmissaoDuimp',
      headerName: 'Status Transmissão',
      flex: 110,
      // valueGetter: ({ row }) => row?.atributosAdicionais?.statusTransmissaoDuimp || '-',
      renderCell: ({ row }) => {
        const statusTransmissao = row?.atributosAdicionais?.statusTransmissaoDuimp;
        const htmlColor = StatusDuimpUtils.getHexadecimalColorByValue(statusTransmissao);
        const label = StatusDuimpUtils.getLabelByValue(statusTransmissao);

        return statusTransmissao ? (
          <Chip
            {...(htmlColor
              ? {
                  icon: (
                    <CircleIcon
                      style={{
                        color: htmlColor,
                      }}
                      fontSize="small"
                    />
                  ),
                }
              : {})}
            label={label}
            size="small"
          />
        ) : (
          '-'
        );
      },
    },
    {
      field: 'atributosAdicionais.geracaoGareEmissaoIcms',
      headerName: 'Status ICMS',
      headerAlign: 'center',
      align: 'center',
      flex: 100,
      renderCell: ({ row }) => {
        const geracaoGareEmissaoIcms = row?.atributosAdicionais?.geracaoGareEmissaoIcms;
        const htmlColor = StatusICMSUtils.getHexadecimalColorByValue(geracaoGareEmissaoIcms);
        const label = StatusICMSUtils.getLabelByValue(geracaoGareEmissaoIcms);

        return geracaoGareEmissaoIcms ? (
          <Chip
            {...(htmlColor
              ? {
                  icon: (
                    <CircleIcon
                      style={{
                        color: htmlColor,
                      }}
                      fontSize="small"
                    />
                  ),
                }
              : {})}
            label={label}
            size="small"
          />
        ) : (
          '-'
        );
      },
    },
    {
      field: 'actions',
      headerName: t('com.muralis.qcx.acoes.label'),
      headerAlign: 'center',
      align: 'center',
      flex: 140,
      renderCell: ({ row }) => <DeclaracaoImportacaoActionsMenu authInfo={authInfo} {...row} />,
    },
  ];

  const breadcrumbs = useMemo(
    () => [
      {
        link: {
          to: '/',
          name: t('com.muralis.qcx.inicio'),
        },
      },
      {
        link: {
          to: t('com.muralis.qcx.url.moduloImportacao'),
          name: t('com.muralis.qcx.importacao.label'),
        },
      },
      {
        text: {
          name: t('com.muralis.qcx.DIDUIMP.declaracoesImportacaoDIDUIMP'),
        },
        default: true,
      },
    ],
    []
  );

  const handleConfigChange = useCallback(({ currentPage, pageSize, filterInputValue, advancedFilter }) => {
    const advancedFiltersGetRequest = [];

    // PARA HABILITAR AS DATAS NOVAMENTE, REMOVER O FALSE DOS IFS
    if (false && advancedFilter?.dataAberturaRange0 && advancedFilter?.dataAberturaRange1) {
      const inicio = getISODateOrTodaysISODate(advancedFilter?.dataAberturaRange0);
      const fim = getISODateOrTodaysISODate(advancedFilter?.dataAberturaRange1);

      advancedFiltersGetRequest.push({
        name: 'dataAberturaInterval',
        value: `${inicio};${fim}`,
      });
    }

    if (false && advancedFilter?.dataPrevisaoChegadaRange0 && advancedFilter?.dataPrevisaoChegadaRange1) {
      const inicio = getISODateOrTodaysISODate(advancedFilter?.dataPrevisaoChegadaRange0);
      const fim = getISODateOrTodaysISODate(advancedFilter?.dataPrevisaoChegadaRange1);

      advancedFiltersGetRequest.push({
        name: 'dataPrevisaoChegadaInterval',
        value: `${inicio};${fim}`,
      });
    }

    if (false && advancedFilter?.dataChegadaRange0 && advancedFilter?.dataChegadaRange1) {
      const inicio = getISODateOrTodaysISODate(advancedFilter?.dataChegadaRange0);
      const fim = getISODateOrTodaysISODate(advancedFilter?.dataChegadaRange1);

      advancedFiltersGetRequest.push({
        name: 'dataChegadaInterval',
        value: `${inicio};${fim}`,
      });
    }

    if (advancedFilter?.dataRegistroInicio) {
      advancedFiltersGetRequest.push({
        name: 'dataRegistroInicio',
        value: formatDateToYYYYMMDD(advancedFilter?.dataRegistroInicio),
      });
    }

    if (advancedFilter?.dataRegistroFim) {
      advancedFiltersGetRequest.push({
        name: 'dataRegistroFim',
        value: formatDateToYYYYMMDD(advancedFilter?.dataRegistroFim),
      });
    }

    if (advancedFilter?.clienteId) {
      const filter = { name: 'clienteId', value: advancedFilter.clienteId };
      advancedFiltersGetRequest.push(filter);
    }

    if (advancedFilter?.processos) {
      const filter = { name: 'processos', value: advancedFilter.processos };
      advancedFiltersGetRequest.push(filter);
    }

    if (advancedFilter?.numerodi) {
      const filter = { name: 'numerodi', value: advancedFilter.numerodi };
      advancedFiltersGetRequest.push(filter);
    }

    if (advancedFilter?.idMaster) {
      const filter = { name: 'idMaster', value: advancedFilter.idMaster };
      advancedFiltersGetRequest.push(filter);
    }

    if (advancedFilter?.numeroConhecimentoHouse) {
      const filter = { name: 'numeroConhecimentoHouse', value: advancedFilter.numeroConhecimentoHouse };
      advancedFiltersGetRequest.push(filter);
    }

    if (advancedFilter?.identificacaoFaturaComercial) {
      const filter = { name: 'identificacaoFaturaComercial', value: advancedFilter.identificacaoFaturaComercial };
      advancedFiltersGetRequest.push(filter);
    }

    setCurrentAdvancedFilter({
      currentPage,
      pageSize,
      filterInputValue,
      advancedFilter,
    });

    // dispara essa funcao sempre que a pagina é alterada ou alguma outra config
    dispatch(
      fetchAllDecImportWithPaginationAsync([
        { name: 'page', value: currentPage },
        { name: 'size', value: pageSize },
        { name: 'numero', value: filterInputValue },
        ...advancedFiltersGetRequest,
      ])
    );
  }, []);

  const handleSuccessBulkOperation = useCallback(() => {
    handleFormDialogCalculoStatus(DONE_STATUS);
    dispatch(resetMode());
    dispatch(success());

    if (currentAdvancedFilter) {
      handleConfigChange(currentAdvancedFilter);
    } else {
      handleConfigChange({
        currentPage: 0,
        pageSize: 10,
        filterInputValue: '',
        advancedFilter: {},
      });
    }
  }, [currentAdvancedFilter, handleConfigChange]);

  const rowsCount = useSelector(selectDeclaracoesImportacaoCount);

  // REGISTER
  const handleEnableRegisterMode = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToRegisterModeDI());
  }, []);

  // CALCULATE
  const handleEnableCalculateMode = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToCalculateModeDI());
  }, []);

  // RELEASE
  const handleEnableReleaseMode = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToReleaseModeDI());
  }, []);

  // RETRANSMITIR
  const handleEnableRetransmitirMode = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToRetransmitirModeDI());
  }, []);

  // LIBERAR
  const handleEnableLiberarMode = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToLiberarModeDI());
  }, []);

  // Usada para cancelar o calcular, liberar e registrar em lote
  const handleCancelSelectOperation = useCallback((event) => {
    event?.stopPropagation();
    dispatch(resetMode());
  }, []);

  const handleConfirmRegister = useCallback(
    (event) => {
      event?.stopPropagation();

      if (isEmptySelectionList) {
        return;
      }

      const mappedDeclImportacao = declaracoesImportacao.filter((declImportacao) =>
        relatedSelectionDeclaracaoImportacaoList.includes(declImportacao.id)
      );

      const payloadToGerar = mappedDeclImportacao.map((declImportacao) => ({
        id: declImportacao.id,
      }));

      dispatch(loadingDI());
      dispatch(
        gerarXMLDIagnosticoLoteAsync({
          data: { payload: payloadToGerar, tipo: tipoXML },
          successCallback: handleSuccessBulkOperation,
        })
      );
    },
    [isEmptySelectionList, relatedSelectionDeclaracaoImportacaoList, tipoXML]
  );

  const handleConfirmCalculate = useCallback(
    (event) => {
      event?.stopPropagation();

      if (isEmptySelectionList) {
        return;
      }

      const mappedDeclImportacao = declaracoesImportacao.filter((declImportacao) =>
        relatedSelectionDeclaracaoImportacaoList.includes(declImportacao.id)
      );

      const idsToCalculate = mappedDeclImportacao.map((declImportacao) => declImportacao.id);

      handleCalcularClick(event, { ids: idsToCalculate });
    },
    [isEmptySelectionList, relatedSelectionDeclaracaoImportacaoList]
  );

  const handleConfirmRelease = useCallback(
    (event) => {
      event?.stopPropagation();

      if (isEmptySelectionList) {
        return;
      }

      const mappedDeclImportacao = declaracoesImportacao.filter((declImportacao) =>
        relatedSelectionDeclaracaoImportacaoList.includes(declImportacao.id)
      );

      const payloadToRelease = mappedDeclImportacao.map((declImportacao) => ({
        id: declImportacao.id,
      }));

      dispatch(loadingDI());
      dispatch(releaseDisEmLoteAsync({ data: payloadToRelease, successCallback: handleSuccessBulkOperation }));
    },
    [isEmptySelectionList, relatedSelectionDeclaracaoImportacaoList]
  );

  const handleConfirmRetransmitir = useCallback(
    (event) => {
      event?.stopPropagation();

      if (isEmptySelectionList) {
        return;
      }

      const mappedDeclImportacao = declaracoesImportacao.filter((declImportacao) =>
        relatedSelectionDeclaracaoImportacaoList.includes(declImportacao.id)
      );

      const payloadToRetransmitir = mappedDeclImportacao.map((declImportacao) => ({
        id: declImportacao.id,
      }));

      dispatch(loadingDI());
      dispatch(
        retransmitirDisEmLoteAsync({ data: payloadToRetransmitir, successCallback: handleSuccessBulkOperation })
      );
    },
    [isEmptySelectionList, relatedSelectionDeclaracaoImportacaoList]
  );

  const handleConfirmLiberar = useCallback(
    (event) => {
      event?.stopPropagation();

      if (isEmptySelectionList) {
        return;
      }

      const mappedDeclImportacao = declaracoesImportacao.filter((declImportacao) =>
        relatedSelectionDeclaracaoImportacaoList.includes(declImportacao.id)
      );

      const payloadToLiberar = mappedDeclImportacao.map((declImportacao) => ({
        id: declImportacao.id,
      }));

      dispatch(loadingDI());
      dispatch(liberarDisEmLoteAsync({ data: payloadToLiberar, successCallback: handleSuccessBulkOperation }));
    },
    [isEmptySelectionList, relatedSelectionDeclaracaoImportacaoList]
  );

  const handleConfirmSelection = useCallback(
    (event) => {
      if (isLiberar) {
        handleConfirmLiberar(event);
      }
      if (isCalculate) {
        handleConfirmCalculate(event);
      }

      if (isRelease) {
        handleConfirmRelease(event);
      }

      if (isRegister) {
        handleConfirmRegister(event);
      }

      if (isRetransmitir) {
        handleConfirmRetransmitir(event);
      }
    },
    [
      isCalculate,
      isRelease,
      isRetransmitir,
      isRegister,
      isLiberar,
      handleConfirmCalculate,
      handleConfirmRegister,
      handleConfirmRelease,
      handleConfirmRetransmitir,
      handleConfirmLiberar,
    ]
  );

  const templateProps = useMemo(
    () => ({
      page: {
        title: t('com.muralis.qcx.DIDUIMP.declaracoesImportacaoDIDUIMP'),
        icon: <ReceiptIcon />,
        breadcrumbs,
      },
      control: {
        ...(isNone
          ? {
              buttonNew: {
                description: t('com.muralis.qcx.DIDUIMP.novoRegistroManualDIDUIMP'),
                onClick: handleButtonNewClickMiddleware,
              },
            }
          : {}),
        others: [
          ...(isNone
            ? [
                {
                  description: 'Calcular',
                  tooltip: {
                    description: "Calcular DI's em Lote",
                  },
                  onClick: handleEnableCalculateMode,
                },
                {
                  description: 'Conferir',
                  tooltip: {
                    description: "Conferir DI's em Lote",
                  },
                  onClick: handleEnableReleaseMode,
                },
                {
                  description: 'Finalizar DI/DUIMP',
                  tooltip: {
                    description: 'Finalizar DI/DUIMP em Lote',
                  },
                  onClick: handleEnableLiberarMode,
                },
                {
                  description: 'Editar DI/DUIMP',
                  tooltip: {
                    description: 'Editar DI/DUIMP em Lote',
                  },
                  onClick: handleEnableRetransmitirMode,
                },
                {
                  description: 'XML Diagnostico',
                  tooltip: {
                    description: 'Baixar XML de diagnostico em Lote',
                  },
                  onClick: (event) => {
                    setTipoXML('DIAGNOSTICO');
                    handleEnableRegisterMode(event);
                  },
                },
                {
                  description: 'XML Registro',
                  tooltip: {
                    description: 'Baixar XML de registro em Lote',
                  },
                  onClick: (event) => {
                    setTipoXML('REGISTRO');
                    handleEnableRegisterMode(event);
                  },
                },
              ]
            : []),
          ...(isRegister || isCalculate || isRelease || isLiberar || isRetransmitir
            ? [
                {
                  description: t('com.muralis.qcx.acoes.confirmarSelecao'),
                  startIcon: <CheckCircleIcon />,
                  color: 'secondary',
                  tooltip: {
                    description: '',
                  },
                  onClick: handleConfirmSelection,
                  disabled: isEmptySelectionList,
                },
                {
                  description: <CancelOutlinedIcon />,
                  variant: 'outlined',
                  color: 'default',
                  tooltip: {
                    description: t('com.muralis.qcx.acoes.cancelar'),
                  },
                  onClick: handleCancelSelectOperation,
                },
              ]
            : []),
        ],
      },
      table: {
        columns,
        rowsCount,
        onConfigChangeCallback: handleConfigChange,
        selectionModel: relatedSelectionDeclaracaoImportacaoList,
        onSelectionModelChange: handleSelectionModelChange,
        checkboxSelection: isRegister || isCalculate || isRelease || isLiberar || isRetransmitir,
      },
    }),
    [columns, breadcrumbs, handleButtonNewClickMiddleware, isRegister, isEmptySelectionList, isCalculate]
  );

  const handleConfirm = () => {
    decisionPromiseResolver();
  };

  const handleCancel = () => {
    decisionPromiseResolver();
  };

  useSubscription(`/topic/fatura-diduimp/alertas/${selectedUnidade}`, async (message) => {
    const errorMessage = message.body;
    setCurrentMessage(errorMessage);
    setConfirmModalOpen(true);
    await new Promise((resolve) => setDecisionPromiseResolver(() => resolve));
    setConfirmModalOpen(false);
  });

  const transmitirDuimpSemTributos = async () => {
    const payload = {
      identificacao: {
        numero: dataDiagnostico?.diagnostico?.[0]?.protocolo,
        versao: '0',
      },
      unidadeNegocioId: unidadeNegocioSelecionada.id,
      isTransmitido: true,
      transmitirComErros: false,
    };

    await doPutQCXRequest(
      ['diduimp', 'v2', 'transmissao-duimp', idDiToTransmissao, 'capa', 'finalizada?transmitirSemTributos=1'],
      payload
    );
  };

  return (
    <SimpleConsultPageTemplate
      pageProps={templateProps.page}
      controlProps={templateProps.control}
      tableProps={templateProps.table}
      tableData={declaracoesImportacao}
      isLoading={finalLoading}
      authInfo={authInfo}
      advancedFilterFormChildren={FiltrosDuimpToConsultPage}
      advancedFilterKeyAccessors={[
        'dataAberturaRange0',
        'dataAberturaRange1',
        'dataPrevisaoChegadaRange0',
        'dataPrevisaoChegadaRange1',
        'dataChegadaRange0',
        'dataChegadaRange1',
        'clienteId',
        'processos',
        'numerodi',
        'calculados',
      ]}
      requiredRoles={['importacao-di-duimp']}
    >
      <QCXFinalFormDialog
        key="form-dialog-processo-registro-manual-di-duimp"
        id="form-dialog-processo-registro-manual-di-duimp"
        title={t('com.muralis.qcx.DIDUIMP.novoRegistroManualDIDUIMP')}
        content={t('com.muralis.qcx.preencherCampoContinuar')}
        dialogActionsProps={{
          button: {
            submit: {
              description: t('com.muralis.qcx.acoes.continuar'),
              size: 'small',
            },
            cancel: {
              description: t('com.muralis.qcx.acoes.cancelar'),
              size: 'small',
            },
          },
        }}
        open={isFormDialogNewOpen}
        initialValues={{}}
        onSubmit={handleProcessoNewSubmit}
        onClose={handleCloseFormDialogNew}
      >
        {() => (
          <QCXMoveFocusInside>
            <QCXFinalTextField
              id="text-field-numero-processo"
              key="text-field-numero-processo"
              name="numeroProcesso"
              label={t('com.muralis.qcx.numeroProcesso')}
              required
            />
          </QCXMoveFocusInside>
        )}
      </QCXFinalFormDialog>
      <QCXFinalFormDialog
        key="form-dialog-dados-registro-siscomex-di-duimp"
        id="form-dialog-dados-registro-siscomex-di-duimp"
        title={t('com.muralis.qcx.dadosRegistroSiscomex')}
        content={formDialogDadosRegistroSiscomexContent}
        dialogActionsProps={{
          button: {
            submit: {
              description: t('com.muralis.qcx.acoes.confirmar'),
              size: 'small',
              disabled: !registroRelatedModel?.confirmacaoPendente,
            },
            cancel: {
              description:
                !registroRelatedModel?.registro ||
                !registroRelatedModel?.dataRegistroSiscomex ||
                registroRelatedModel?.confirmacaoPendente
                  ? t('com.muralis.qcx.acoes.cancelar')
                  : t('com.muralis.qcx.acoes.fechar'),
              size: 'small',
            },
          },
        }}
        open={isFormDialogDadosRegistroSiscomexOpen}
        initialValues={registroRelatedModel}
        onSubmit={handleDadosRegistroSiscomexSubmit}
        onClose={handleCloseFormDialogDadosRegistroSiscomex}
      >
        {({ initialValues }) => (
          <Grid item container spacing={2} xs={12}>
            <Grid item xs={12}>
              <QCXMoveFocusInside>
                <QCXFinalTextField
                  key="numero-registro-siscomex-field"
                  id="numero-registro-siscomex-field"
                  name="registro"
                  label={t('com.muralis.qcx.numeroRegistro')}
                  disabled={!!initialValues?.registro && !initialValues?.confirmacaoPendente}
                  validate={required}
                  required
                />
              </QCXMoveFocusInside>
            </Grid>
            <Grid item xs={12}>
              <QCXFinalTextField
                key="numero-transmissao-siscomex-field"
                id="numero-transmissao-siscomex-field"
                name="numeroTransmissao"
                label={t('com.muralis.qcx.numeroTransmissao')}
                disabled={!!initialValues?.numeroTransmissao && !initialValues?.confirmacaoPendente}
              />
            </Grid>
            <Grid item xs={12}>
              <QCXFinalDatePickerField
                key="data-registro-siscomex-picker-field"
                id="data-registro-siscomex-picker-field"
                name="dataRegistroSiscomex"
                label={t('com.muralis.qcx.dataRegistro')}
                defaultValue={defaultDateValue}
                disabled={!!initialValues?.dataRegistroSiscomex && !initialValues?.confirmacaoPendente}
                validate={required}
                required
              />
            </Grid>
          </Grid>
        )}
      </QCXFinalFormDialog>
      <QCXConfirmDialog
        key="confirm-dialog-reabrir-due"
        id="confirm-dialog-reabrir-due"
        open={reabriDiPopUpConfig?.isPopUpOpen}
        title={reabriDiPopUpConfig?.title}
        content={reabriDiPopUpConfig?.message}
        endContent={reabriDiPopUpConfig?.endMessage}
        onConfirm={reabriDiPopUpConfig.confirmPrimaryAction}
        onClose={reabriDiPopUpConfig?.reset}
      />
      <QCXConfirmDialog
        key="confirm-dialog-dados-registro-siscomex-di-duimp"
        id="confirm-dialog-dados-registro-siscomex-di-duimp"
        open={operationOfInformarDadosRegistroSiscomex?.active}
        title={operationOfInformarDadosRegistroSiscomex?.title}
        buttonGroupOptions={{
          confirm: {
            description: t('com.muralis.qcx.expressao.sim'),
          },
          cancel: {
            description: t('com.muralis.qcx.expressao.nao'),
          },
        }}
        content={operationOfInformarDadosRegistroSiscomex?.message}
        endContent={operationOfInformarDadosRegistroSiscomex?.endMessage}
        onConfirm={operationOfInformarDadosRegistroSiscomex.confirm}
        onClose={handleCloseDadosRegistroSiscomexOperation}
      />

      <QCXConfirmDialog
        key="confirm-dialog-diagnostico-crawler-di"
        id="confirm-dialog-diagnostico-crawler-di"
        open={diagnosticoDiPopUpConfig?.isPopUpOpen}
        title={diagnosticoDiPopUpConfig?.title}
        content={diagnosticoDiPopUpConfig?.message}
        endContent={diagnosticoDiPopUpConfig?.endMessage}
        onConfirm={diagnosticoDiPopUpConfig.confirmPrimaryAction}
        onClose={diagnosticoDiPopUpConfig?.reset}
      />

      <QCXConfirmDialog
        key="confirm-dialog-apagar-transmissao-duimp"
        id="confirm-dialog-apagar-transmissao-duimp"
        open={deleteTransmissaoDuimpPopup?.isPopUpOpen}
        title={deleteTransmissaoDuimpPopup?.title}
        content={deleteTransmissaoDuimpPopup?.message}
        endContent={deleteTransmissaoDuimpPopup?.endMessage}
        onConfirm={deleteTransmissaoDuimpPopup.confirmPrimaryAction}
        onClose={deleteTransmissaoDuimpPopup?.reset}
      />

      {isNovoRelatorio ? (
        <RelatorioTransmissaoDuimpPopup
          open={isModalNovoRelatorioDuimpOpen}
          onClose={() => {
            setIsModalNovoRelatorioDuimpOpen(false);
            setIsNovoRelatorio(false);
          }}
          relatorio={{ ...resultadoRelatorioDuimp }}
        />
      ) : (
        <TransmissaoModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          title={`${t('com.muralis.qcx.extracaoDiagnostico.tituloExtracao')}: ${processoDiagnostico}`}
          buttonTitle={t('com.muralis.qcx.extracaoDiagnostico.transmitirParaRegistro')}
          isDuimp={isDuimpSelected}
          onConfirm={() => {
            setIsModalOpen(false);
            handleDiagnosticoCrawlerClick({
              declaracaoImportacao: {
                id: idDiToTransmissao,
                processo: processoDiagnostico,
                tipo: 'REGISTRO',
                transmitirComImpedimentos: 1,
              },
            });
          }}
          disabled={!canGerenateDIReg || !canGenerateTransmissaoRegistroDI}
          buttonComponent={
            showButtonTransmitirSemTributos
              ? () => (
                  <Button
                    variant="contained"
                    onClick={transmitirDuimpSemTributos}
                    title="Transmitir itens sem tributação"
                    color="primary"
                  >
                    Transmitir itens sem tributação
                  </Button>
                )
              : null
          }
        >
          {dataDiagnostico ? (
            <TransmissaoRenderDadosDi
              diagnostico={dataDiagnostico.diagnostico}
              isDuimp={isDuimpSelected}
              fatura={faturaSelected}
            />
          ) : null}
        </TransmissaoModal>
      )}

      <ConfirmationModal
        open={confirmModalOpen}
        message={`${currentMessage}`}
        singleAction
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title="Alerta"
        isHtmlMessage
      />

      <ModalRelatorioCalculo
        isModalOpen={exibirModalRelatorioCalculoDi}
        setIsModalOpen={setExibirModalRelatorioCalculoDi}
        title={`${t('com.muralis.qcx.extracaoDiagnostico.tituloExtracao')}: ${processoDiagnostico}`}
        buttonTitle={t('com.muralis.qcx.extracaoDiagnostico.transmitirParaRegistro')}
        isDuimp={isDuimpSelected}
        onConfirm={() => {
          setIsModalOpen(false);
        }}
        disabled={!canGerenateDIReg || !canGenerateTransmissaoRegistroDI}
      >
        <h1>oi</h1>
      </ModalRelatorioCalculo>

      <SelectDespachanteModal
        isModalOpen={exibirModalDespachante}
        setIsModalOpen={setExibirModalDespachante}
        disabled={!canGerenateDIReg || !canGenerateTransmissaoRegistroDI}
      />
    </SimpleConsultPageTemplate>
  );
}

function isDuimp(atributosAdicionais) {
  return atributosAdicionais?.tipoDeclaracao?.code === '50';
}
